import React from "react";
import Button from "@material-ui/core/Button";
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";

interface CloseButtonProps {
    title: string;
    onClose: () => void;
}

const CloseButton = (props: CloseButtonProps) => {
    const {title, onClose} = props;
    return (
        <ThemeProvider theme={closeButtonTheme}>
            <Button
                variant={'outlined'}
                color={'secondary'}
                onClick={onClose}
            >
                {title}
            </Button>
        </ThemeProvider>
    );
};


const closeButtonTheme = createMuiTheme({
    overrides: {
        MuiButton: {
            outlinedSecondary: {
                color: '#C30D00',
                borderColor: '#C30D00',
                borderWidth: '2px',
                '&:hover': {
                    borderWidth: '2px',
                }
            }
        }
    }
});


export default CloseButton;